import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Svg8594 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 300,
	height: 281,
	viewBox: "0 0 300 281",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.896 162.965C-14.5972 110.617 12.6136 50.9008 68.5995 29.6196L126.638 7.56399C182.661 -13.7297 246.324 11.4793 268.805 63.8019L292.105 118.035C314.598 170.389 287.381 230.099 231.395 251.38L173.357 273.436C117.34 294.73 53.677 269.521 31.1963 217.204L7.896 162.965Z",
			fill: "url(#paint0_linear_29_955)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28 252H31",
			stroke: "black",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41.5 252H63.5",
			stroke: "black",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75.5 252H238.5",
			stroke: "black",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M255 252H272",
			stroke: "black",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 87,
			y: 45.9999,
			width: 126,
			height: 206,
			rx: 9,
			stroke: "black",
			strokeWidth: 6
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M135.711 35.1621C136.824 33.4942 138.697 32.4926 140.702 32.4926L159.269 32.4926C161.274 32.4926 163.146 33.4942 164.259 35.1621L166.252 38.1474C168.912 42.1346 166.054 47.4779 161.261 47.4779L138.71 47.4779C133.916 47.4779 131.058 42.1346 133.719 38.1474L135.711 35.1621Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 98,
			y: 69,
			width: 112,
			height: 180,
			rx: 6,
			fill: "url(#paint1_linear_29_955)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M112 119C114.14 113.711 119.155 110 125 110C130.845 110 135.86 113.711 138 119",
			stroke: "black",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M125.238 89.7306C122.45 87.9099 119.167 87.2164 115.988 88.0682C112.808 88.9201 110.311 91.1625 108.807 94.1332",
			stroke: "black",
			strokeWidth: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M194.203 94.1331C192.699 91.1624 190.202 88.92 187.023 88.0681C183.844 87.2163 180.56 87.9098 177.772 89.7305",
			stroke: "black",
			strokeWidth: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M175 150C170.884 160.577 161.24 168 150 168C138.76 168 129.116 160.577 125 150",
			stroke: "black",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M166 119C168.14 113.711 173.155 110 179 110C184.845 110 189.86 113.711 192 119",
			stroke: "black",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 80,
			cy: 25,
			r: 4.5,
			stroke: "#50BDE7",
			strokeWidth: 3
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 231,
			cy: 67,
			r: 4.5,
			stroke: "#ECCD42",
			strokeWidth: 3
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 166,
			cy: 6,
			r: 4,
			fill: "#50BDE7"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 64,
			cy: 55,
			r: 4,
			fill: "#ECCD42"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 239,
			cy: 47,
			r: 4,
			fill: "#50BDE7"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 187,
			y1: 24,
			x2: 187,
			y2: 36,
			stroke: "#ECCD42",
			strokeWidth: 4,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 193,
			y1: 30,
			x2: 181,
			y2: 30,
			stroke: "#ECCD42",
			strokeWidth: 4,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 120.495,
			y1: 19,
			x2: 120.495,
			y2: 23,
			stroke: "#CB04F2",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 120.495,
			y1: 8,
			x2: 120.495,
			y2: 12,
			stroke: "#CB04F2",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 117,
			y1: 15.495,
			x2: 113,
			y2: 15.495,
			stroke: "#CB04F2",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 128,
			y1: 15.495,
			x2: 124,
			y2: 15.495,
			stroke: "#CB04F2",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 118.022,
			y1: 17.9713,
			x2: 115.193,
			y2: 20.7998,
			stroke: "#CB04F2",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 125.8,
			y1: 10.1931,
			x2: 122.971,
			y2: 13.0216,
			stroke: "#CB04F2",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 118.029,
			y1: 13.0216,
			x2: 115.2,
			y2: 10.1932,
			stroke: "#CB04F2",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 125.807,
			y1: 20.7998,
			x2: 122.978,
			y2: 17.9714,
			stroke: "#CB04F2",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_29_955",
			x1: 150,
			y1: 0,
			x2: 150,
			y2: 281,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#EDEDED" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#EDEDED",
				stopOpacity: .4
			})]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_29_955",
			x1: 154,
			y1: 69,
			x2: 154,
			y2: 249,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#9CF752" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#46BE43"
			})]
		})] })
	]
});
export default Svg8594;
